var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-form',[_c('v-select',{staticClass:"language-selector",attrs:{"items":_vm.langList,"outlined":"","width":"50"},on:{"change":_vm.loadLanguageAsync},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.$t(("msg." + (item.value)))))]}},{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.$t(("msg." + (item.value)))))]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }